export default {
  "FoodOpC_Notifications_Full_time_tbyY": "Todas las horas",
  "FoodOpC_Notifications_No_order_CPhU": "Sin pedido mínimo",
  "FoodOpC_Notifications_All_stores_lcyT": "Todas las tiendas",
  "FoodOpC_Notifications_All_payments_ERiC": "Todos los métodos de pago",
  "FoodOpC_Notifications_Full_service_HBkd": "Todas las ciudades",
  "FoodOpC_Notifications_Some_stores_BdsO": "Sólo determinadas tiendas",
  "coupon": {
    "other": {
      "time": "Válido hasta  {name} ",
      "hide": "Ocultar",
      "cost": "Aplicable a  {name} ",
      "min": "más de  {name} ",
      "show": "Más detalles",
      "cardBin": "Solo disponible si la bandeja de tarjetas es  {name} ",
      "limit": "Solo  {name} ",
      "new": "Solo para nuevos clientes",
      "max": "Aplicable a  {name} ",
      "off": "OFF",
      "limitUse": "Solo  {name} ",
      "use": "Aplicable en  {name} "
    },
    "costType": {
      "order": "Pedidos",
      "delivery": "Tarifa de entrega",
      "meals": "Tarifa de comida"
    },
    "useRuleWeekDay": {
      "Monday": "Lunes",
      "Thursday": "Jueves",
      "Saturday": "Sábado",
      "Tuesday": "Martes",
      "Sunday": "Domingo",
      "Friday": "Viernes",
      "Wednesday": "Miércoles"
    },
    "payTypeList": {
      "all": "Todos los medios de pago",
      "card": "Tarjeta",
      "pay": "99Pay - Saldo",
      "pos": "Terminal Punto de Venta",
      "money": "Efectivo"
    }
  }
}